import DataTile from "./DataTile";
import {fetchTargets} from "../../../actions";
import React from "react";
import {bbScopeIcon,} from "../../../util/bbHelpers";
import {useSelector} from "react-redux";

const Tile = (props) => {

    const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customerInView} = useSelector(({customer}) => customer);

    const customerIdToUse = customerId ? customerId : customerInView;

    const valueFunction = (stateData) => stateData ? stateData[customerIdToUse] ? stateData[customerIdToUse].targets_oos : null : null;

    // const translateValueToRisk = (value) => {
    //     if (typeof value !== "number") {
    //         return null
    //     } else if (value <= 0) {
    //         return 0
    //     } else if (value <= 3) {
    //         return 1
    //     } else if (value <= 7) {
    //         return 2
    //     } else if (value <= 15) {
    //         return 3
    //     } else {
    //         return 4
    //     }
    // }

    // const colorFunction = (stateData) => {
    //     const num = valueFunction(stateData);
    //     return bbTranslateRiskToColor(translateValueToRisk(num));
    // }

    // const riskRibbon = (stateData) => {
    //     const num = translateValueToRisk(valueFunction(stateData));
    //     return num
    //         ? <RiskRibbon ratingBy5={num} />
    //         : null;
    // }

    return (
        <DataTile
            // colorBgFunction={colorFunction}
            color="light"
            subTitle="Targets OOS"
            tipText={`Number of detected targets that are designated as "Out of Scope."  OOS Targets are passively monitored, but are not being actively attacked by CIRT (and therefore may be more vulnerable).`}
            icon={bbScopeIcon(true, 70, true)}
            stateName="customer"
            stateElement="metaTargets"
            // useDeepDataStore
            // deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse].targets : null : null}
            stateLoaderName="loadingTargets"
            stateLoaderError="loadingTargetsError"
            stateFetchAction={fetchTargets(
                {
                    customerId: customerIdToUse
                }
            )}
            preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            ribbonFunction = {null}
            requiresModule={"monitor"}
        />
    )
}

export default Tile;